import { render } from "./Catalog.vue?vue&type=template&id=63e5b7de&scoped=true&ts=true"
import script from "./Catalog.vue?vue&type=script&lang=ts"
export * from "./Catalog.vue?vue&type=script&lang=ts"

import "./Catalog.vue?vue&type=style&index=0&id=63e5b7de&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63e5b7de"]])

export default __exports__